import * as React from "react";
import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";

import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import { Form, Formik } from "formik";
import { Stack } from "@mui/system";
import TextfieldWrapper from "../../../../../../Components/FormComponents/TextfieldWrapper";
import ScoreCardSelector from "../../../../../Admin/components/CallbiSelector";
import { Divider, Typography } from "@mui/material";
import * as Yup from "yup";
import SelectWrapper from "../../../../../../Components/FormComponents/Select";
import CheckboxWrapper from "../../../../../../Components/FormComponents/CheckboxWrapper";

export default function CreateCampaignForm({ createInboundCampaign }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button variant="contained" onClick={handleClickOpen}>
        Create new QA Queue
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Create QA Queue</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{
              name: "",
              description: "",
              type: "",
              callbi_scorecard: "",
              minEvaluations: 2,
              maxEvaluations: 5,
              full_verification: false,
            }}
            validationSchema={Yup.object({
              name: Yup.string().required("Required"),
              description: Yup.string().required("Required"),
              type: Yup.string().required("Required"),

              minEvaluations: Yup.number().required("Required"),
              maxEvaluations: Yup.number().required("Required"),
            })}
            onSubmit={(values) => {
              createInboundCampaign.mutate(values);
              handleClose();
            }}
          >
            {({ errors }) => {
              return (
                <Form>
                  <Stack sx={{ py: 2 }} spacing={2}>
                    <TextfieldWrapper name="name" label="Queue Name" />
                    <TextfieldWrapper name="description" label="Description" />
                    <Typography
                      sx={{ mt: 1 }}
                      variant="caption"
                      color="GrayText"
                    >
                      Select the type of queue you want to create
                    </Typography>

                    <SelectWrapper
                      name="type"
                      label="Queue Type"
                      options={[
                        { value: "sale", label: "Sale Verification" },
                        { value: "inbound", label: "Inbound Call Evaluations" },
                        {
                          value: "outbound",
                          label: "Outbound Call Evaluations",
                        },
                        { value: "ticket", label: "Ticket Evaluations" },
                      ]}
                    />

                    <Divider />

                    <Typography sx={{ my: 1 }} variant="h6" color="GrayText">
                      Queue Settings
                    </Typography>

                    <ScoreCardSelector name="callbi_scorecard" />

                    <CheckboxWrapper
                      name="full_verification"
                      label="100% Verification Required"
                    />

                    <TextfieldWrapper
                      name="minEvaluations"
                      type="number"
                      label="Minimum amount of evaluation allocated to Qa consultant at a time"
                    />
                    <TextfieldWrapper
                      name="maxEvaluations"
                      type="number"
                      label="Maximum amount of evaluation allocated to Qa consultant at a time"
                    />
                  </Stack>

                  <Stack direction="row" justifyContent="flex-end" spacing={2}>
                    <Button
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      }} > cancel

                    </Button>
                    <Button variant="contained" type="submit" color="secondary">
                      save
                    </Button>
                  </Stack>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
